var ContactsData = React.createContext({});
export var ContactsDataProvider = ContactsData.Provider;
export var ContactsDataConsumer = ContactsData.Consumer;
export default ContactsData;